import React from 'react';
import MediaCard from './MediaCard';

const MediaGrid = ({ items = [], onItemClick }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      {items.map((item, index) => (
        <MediaCard
          key={item.id || index}
          item={item}
          onClick={() => onItemClick?.(item)}
        />
      ))}
    </div>
  );
};

export default MediaGrid;

